// @ts-nocheck
import { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';

import { useMatch, useNavigate } from 'react-router-dom';

import { RootState } from 'src/store/reducers';

import { GlobalOrderDetailsPayload } from '@interfaces/myPurchasesInterfaces';

import PageLayout from '@components/PageLayout';
import OrderDetailOverview from '@components/my-purchases/OrderDetailOverview';

import ArrowLeft from '@images/svg-icons/arrowLeft.svg';

import { getGlobalOrderDetails } from '@services/myPurchasesServices';

import { getLabelFallback } from '@utils/utils';

const OrderDetail = (): JSX.Element => {
    const orderDetailLabel = getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_PAGE_TITLE');
    const orderDetailBackLabelMobile = getLabelFallback('MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_BACK_CTA_MOBILE_LABEL');
    const orderDetailBackLabel = getLabelFallback(
        'MYPURCHASES_ONLINE_ORDERS_ORDER_DETAIL_BACK_CTA_LABEL'
    );

    const dispatch = useDispatch();

    const isMobile = useSelector((state: RootState) => state.common.isMobile);
    const config = useSelector((state: RootState) => state.common.config);
    const globalOrderDetails = useSelector(
        (state: RootState) => state.myPurchases.globalOrderDetails
    );

    const navigate = useNavigate();
    const match = useMatch(config.pagesUrl.myPurchases.orderDetail);

    /*
     * Verify if the user enters in order detail page from cta or url
     * If he enters from cta find the order detail from the orders list otherwise the service is called
     */
    useEffect(() => {
        if (match.params['id']) {
            const payload: GlobalOrderDetailsPayload = {
                isMockRequest: config.mockRequest,
                orderId: Number(match.params['id']),
                storeId: config.storeId,
                currency: config.currencyCode,
                pageNumber: 1,
                pageSize: 50,
            };
            dispatch(getGlobalOrderDetails(payload));
        }
    }, [match]);

    return (
        <PageLayout
            data_element_id="AccountSummary_History"
            hideMenu
            labelMenu={orderDetailLabel}
            backLabel={orderDetailBackLabelMobile}
            onBackButtonClick={() => navigate(config.pagesUrl.myPurchases.onlineOrders)}
        >
            <div className="order-detail">
                {!isMobile && (
                    <div
                        role="region"
                        aria-label="Order detail header"
                        className="order-detail-header"
                    >
                        <button
                            className="back-button online-back"
                            onClick={() => navigate(config.pagesUrl.myPurchases.onlineOrders)}
                        >
                            <span className="start-icon">
                                <ArrowLeft />
                            </span>
                            <span>{orderDetailBackLabel}</span>
                        </button>
                        <div className="primary-title">{orderDetailLabel}</div>
                    </div>
                )}
                {globalOrderDetails && <OrderDetailOverview orderDetail={globalOrderDetails} />}
            </div>
        </PageLayout>
    );
};

export default OrderDetail;
